import { useState, useEffect, useContext } from 'react'
import Time from './Time';
import MixDate from './MixDate';
import { App, Avatar, Button, Dropdown, Space } from 'antd';
import GlobalContext from '../../../utils/GlobalContext';
import Api from '../../../utils/apis/Api';
import { DownOutlined, UserOutlined } from '@ant-design/icons';
// import Weather from './Weather';
export default function Header(props) {
    const { title } = useContext(GlobalContext)
    const [userInfo, setUserInfo] = useState();

    const { modal } = App.useApp();

    useEffect(() => {
        if (window.location.pathname.endsWith('/main/login')) {
            return
        }
        Api.getInfo().then(resp => {
            setUserInfo(resp.data?.user)
        }).catch(() => {
            window.location.href = `${process.env.PUBLIC_URL}/main/login`
        })
    }, [])

    useEffect(() => {
        document.title = title
    }, [title])
    return <>
        <div className='fill layout-h center' style={{
            marginBottom: 24
        }}>
            <Time />
            <div className='divider' />
            <MixDate />
        </div>
        <div className='title layout-v center ' style={{

        }} >
            {title}
        </div>
        <div className='fill layout-h center' style={{
            justifyContent: "flex-end"
        }}>
            {userInfo && <Dropdown menu={{
                onClick: ({ key }) => {
                    if (key === 'logout') {
                        modal.confirm({
                            title: '提示',
                            content: '确认注销并退出系统？',
                            onOk: () => {
                                Api.logout().then(resp => {
                                    window.location.href = `${process.env.PUBLIC_URL}/main/login`;
                                });
                            }
                        })
                    }
                },
                items: [{
                    key: 'logout',
                    label: '退出登录'
                }]
            }}>
                <Button type="text" style={{
                    color: '#fff',
                    height: 48,
                    marginBottom: 24,
                    padding: "4px 24px"
                }} icon={<Avatar icon={<UserOutlined />} />}>
                    <Space>

                        <div style={{
                            fontSize: 18,
                        }}>{userInfo?.nickName || userInfo.userName}</div>
                        {/* <DownOutlined /> */}
                    </Space>
                </Button>
            </Dropdown>}
            {/* <Weather /> */}
        </div>
    </>;
}